import React from 'react';
import classNames from 'classnames';

import classes from './ChallengeBackgroundImg.module.scss';

type ChallengeBackgroundImgProps = {
  className?: string;
};
// image as background instead of <img> so the inset box-shadow is visible:
// inset shadow paints above the background layer but under a replaced element's content
const ChallengeBackgroundImg = ({ className }: ChallengeBackgroundImgProps) => (
  <div
    className={classNames(classes.background, className)}
    role="img"
    aria-label="challenges background"
  />
);

export { ChallengeBackgroundImg };
